import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useJobInformationConfig = () => {
    const { t } = useTranslation();

    return useMemo(() => [
        {
            name: t("effective-date"),
            key: "startDate",
        },
        {
            name: t("job"),
            key: "job",
        },
        {
            name: t("hourly-or-salary"),
            key: "hourlyOrSalaried",
        },
        {
            name: t("pay-currency"),
            key: "currency",
        },
        {
            name: t("hourly-rate"),
            key: "hourlyRate",
        },
        {
            name: t("other-rate1"),
            key: "otherRate1",
        },
        {
            name: t("other-rate2"),
            key: "otherRate2",
        },
        {
            name: t("other-rate3"),
            key: "otherRate3",
        },
        {
            name: t("other-rate4"),
            key: "otherRate4",
        },
        {
            name: t("salary"),
            key: "salary",
        },
        {
            name: t("is-multiple-job"),
            key: "isMultipleJob",
        },
    ], [t]);
}
